import React from 'react'
import { useState, useEffect } from 'react'
import axios from 'axios'
import Toast from 'react-bootstrap/Toast'
import logo from '../assets/logo/logo.jpg'


export default function Editregionform(props) {
    let coderegioncourant = props.coderegion
    const[btnvalider, SetBtnvalider] =  useState(false)
    const objreg = {
        code: props.coderegion,
        region: "",
        langue: "",
        sourceinfo: "",
        dateCreation: "",
        bulletinPdf: null,
        bulletinImage: null,
        bulletinAudio: null,
        alertMessage: "",
        pays: ""
    }
    const [objregioninfo, SetObjregioninfo] = useState({
        code: props.coderegion,
        region: "",
        langue: "",
        sourceinfo: "",
        dateCreation: "",
        bulletinPdf: null,
        bulletinImage: null,
        bulletinAudio: null,
        alertMessage: "",
        pays: ""
    })
    const [objRegion, setObjRegion] = useState({        
        langue: "",
        sourceinfo: "",
        dateCreation: null,    
        alertMessage: ""        
      });
    const[bulletinPdf, SetBulletinPdf] = useState("");
    const[bulletinImage, SetBulletinImage] =  useState("");
    const[bulletinAudio, SetBulletinAudio] = useState("");
    const[region, SetRegion]=useState("") 
    const[langue, SetLangue] = useState("")
    const [showMsg, SetShowMsg] = useState(false);
    //const [showform, SetShowForm ] = useState(true);
    const updateMessage ="Mise à jour effectuée avec Succès"


    const toggleShowMsg = () => {SetShowMsg(false) } 
    const ouvreMsg = () => {SetShowMsg(true); SetBtnvalider(false)}
    // eagrimet.online
    // const urlput = `http://localhost:8000/eagrimetApi/regionInfo/${coderegioncourant}/`;  
    const urlput = `https://eagrimet.online/eagrimetApi/regionInfo/${coderegioncourant}/`;  

    // chargement les données du pays à modifier
    //const urlgetregioninfo = `http://localhost:8000/eagrimetApi/regionInfo/?code=${coderegioncourant}`
    const urlgetregioninfo = `https://eagrimet.online/eagrimetApi/regionInfo/?code=${coderegioncourant}`
    const  axiosconfig = {
        headers: {
        "Content-Type": "application/json",
        Authorization: "Token f976960761d6c971c5be927bb45c4abfa1fcc352",
        }
     };

     useEffect( () => {
        const cherchregioninfo = async() =>{
             axios.get(urlgetregioninfo, axiosconfig)           
                .then((resultat) => {
                console.log(urlgetregioninfo)          
                console.log("resultat trouvé ", resultat.data);
                //Object.assign(objregioninfo, resultat.data) 
                //SetObjregioninfo({...objregioninfo,   inobj })
                const newobjRegion = { ...objregioninfo };
                const newobjRegion2 = { ...objRegion };
                newobjRegion2.region = resultat.data.region
                console.log("echo req de API", resultat.data.length )
                    let result = resultat.data.map(r => {
                        //console.log(r.region); 
                        Object.assign(objregioninfo, r)                        
                        Object.assign(objRegion, r)
                        SetLangue(r.langue)
                        SetObjregioninfo({...objregioninfo, region: r.region, langue : r.langue, sourceinfo : r.sourceinfo, alertMessage : r.alertMessage, pays: r.pays})                                           
                        })   
                //setObjRegion({...objRegion, region : resultat.data["region"] });
                //Object.assign(newobjRegion, resultat.data) ;     
               // SetObjregioninfo({...objregioninfo, langue : resultat.data.langue, sourceinfo : resultat.data.sourceinfo, alertMessage : resultat.data.alertMessage})                                           
                //SetRegion({...objRegion, region : resultat.data["region"] })
                
               


                console.log("resultat langue only", langue)
                console.log("resultat mini", objRegion);  
                console.log("resultat 1", objregioninfo);  
                 
                           
                console.log("type", typeof(resultat.data))
             }
            ) 
           .catch((err) => console.log(err));  
        };
        cherchregioninfo()
     }, [coderegioncourant])


    async function submit(e) {
        let axiosConfig = {
          headers : {
             "Content-Type": "multpart/form-data",           
             
          }
        }
    
    
        const form = document.getElementById("form");
        e.preventDefault();
        const formdata = new FormData(form);
    
        // console.log([...formdata])
        formdata.append("code", objregioninfo.code);
        formdata.append("region", objregioninfo.region);
        formdata.append("langue", objregioninfo.langue);
        formdata.append("sourceinfo", objregioninfo.sourceinfo);
        formdata.append("dateCreation", "");
        formdata.append("bulletinPdf", bulletinPdf);             
        formdata.append("bulletinImage",bulletinImage);  
        formdata.append("bulletinAudio",bulletinAudio);     
        formdata.append("alertMessage", objregioninfo.alertMessage);       
        formdata.append("pays", objregioninfo.pays);
    
        console.log([...formdata]);
    
        axios.patch(
            urlput,
          formdata, 
          axiosConfig      
        )
          .then((result) => {
            ouvreMsg();
            console.log(result.status, showMsg);  
             
            
          })
          .catch((err) => console.log(err));
          //window.location.reload(); 
          
      }
    

     


    function handle(e){
        //const cloneobjRegion = { ...objRegion };
        //cloneobjRegion[e.target.id] = e.target.value;
        //setObjRegion(cloneobjRegion);
       // console.log(cloneobjRegion);     
       //SetObjregioninfo({...objregioninfo, langue: e.target.value})}   

    }

    

   //if (showform){     
  return (     
    
    <div className='justify-content-center container p-2'>        
        <h2>Edit <b>{objregioninfo.pays} - {objregioninfo.region}</b></h2>
            <form id="form" onSubmit={(e) => submit(e)} >  
                <div className='d-flex flex-row-reverse'>                
                        {showMsg && 
                        <Toast show={showMsg} onClose={toggleShowMsg} >
                        <Toast.Header className='bg-success'>
                            <img src={logo} className='rounded-circle' height={30}  alt=""/>
                            <strong>&nbsp; eAgrimet</strong>
                        </Toast.Header>
                        <Toast.Body>{updateMessage} </Toast.Body>            
                    </Toast>
                    }                
                </div>
            
      <div className="row">
         
            <div className="mb-4 col-3">                   
            <input 
                placeholder="code"
                type="text"
                id="code"               
                onChange={(e) => handle(e)}
                className="form-control" 
                disabled
                value={objregioninfo.code}
            />
            </div>
            <div className="mb-4 col-3"> 
            <input
           
            type="text"
            id="region"            
            onChange={(e) => handle(e)}
            className="form-control"
            disabled
            value={objregioninfo.region}
            />
            </div>
        </div>
        <div className="row">

        <div className="mb-4 col-3"> 
        <input
          placeholder="langue"
          type="text"
          id="langue"   
           className="form-control"
          value={objregioninfo.langue}                
          onChange={e => SetObjregioninfo({...objregioninfo, langue : e.target.value})}         
        />
        </div>
        <div className="mb-4 col-3"> 
        <input
          placeholder="Source"
          type="text"
          id="sourceinfo"   
          className="form-control"
          value={objregioninfo.sourceinfo}
          onChange ={e =>  {SetObjregioninfo({...objregioninfo, sourceinfo: e.target.value}); SetBtnvalider(true)}} 
        />
        </div>
        </div>
        <div className="mb-4 col-6"> 
        <textarea
          placeholder="alertMessage"
          id="alertMessage"          
          value={objregioninfo.alertMessage}
          className="form-control"
          onChange={e => {SetObjregioninfo({...objregioninfo, alertMessage : e.target.value}); SetBtnvalider(true)}}

        />
        </div>
        <div className="row">
            <div className="mb-4 col-4" hidden> 
            <label for="bulletinPdf" className="form-label"><a href={objregioninfo.bulletinPdf} target="_blank">PDF</a></label>
            
            <input
              placeholder="bulletinPdf"
              id="bulletinPdf"
              type="file"       
              accept="application/pdf, .pdf" 
              className="form-control"
              onChange={(e) => {SetBulletinPdf(e.target.files[0]); console.log("bulletin", bulletinPdf)}}
            />
            </div>
        <div className="mb-4 col-4" hidden> 
        <label for="bulletinImage" className="form-label"><a href={objregioninfo.bulletinImage} target="_blank">Image</a></label>
        <input
          placeholder="bulletinImage"
          id="bulletinImage"          
          type="file"
          onChange={(e) => SetBulletinImage(e.target.files[0])}
          accept="image/*"
          className="form-control"
        />
        </div>
        <div className="mb-4 col-3">
        <label for="bulletinAudio" className="form-label"><a href={objregioninfo.bulletinAudio} target="_blank">Audio</a></label>
        <input
          placeholder="bulletinAudio"
          id="bulletinAudio"          
          type="file"
          onChange={(e) =>{ SetBulletinAudio(e.target.files[0]); SetBtnvalider(true)}}
          className="form-control"
        />
        </div> 
        

        <div className=" row offset-6 ">  
         <button  type="reset" className="btn btn-danger col-2 mx-3"> Annuler</button>   
          {btnvalider && <button  type="button" className="btn btn-success col-2" data-toggle="popover" title="Popover title"  data-content="toto"  onClick={(e) => {submit(e); } }> Valider</button> }    
        </div>
            

        </div>
        
      </form>  
        
    </div>

  ) // fin return
}// fin 



